export function getDate(timer, is) {
    // 获取现行时间
    var myDate;
    if (timer) {
        myDate = new Date(timer);
    } else {
        myDate = new Date();
    }
    var year = myDate.getFullYear();
    var month = myDate.getMonth() + 1 < 10
                ? "0" + (myDate.getMonth() + 1)
                : myDate.getMonth() + 1;
    var date = myDate.getDate() < 10 ? "0" + myDate.getDate() : myDate.getDate();
    var h = myDate.getHours() < 10 ? "0" + myDate.getHours() : myDate.getHours();
    var m = myDate.getMinutes() < 10
                ? "0" + myDate.getMinutes()
                : myDate.getMinutes();
    var s = myDate.getSeconds() < 10
                ? "0" + myDate.getSeconds()
                : myDate.getSeconds();
    return is ? year + '-' + month + '-' + date + ' ' + h + ':' + m : {
        n: year,
        y: month,
        r: date,
        h: h,
        f: m,

    };
}
export function parseQueryString(url, money, hash) {
    // 解析url返回JSON对象
    hash = hash ? hash : "&";
    money = money ? money : "?";
    var text = "";
    var data = {};
    if (url.indexOf(money) != -1) {
      text = url.substr(url.indexOf(money) + 1, url.length);
      if (url.indexOf(hash) != -1) {
        text = text.split(hash);
        text.forEach(function (item) {
          var d = item.split("=");
          data[d[0]] = d[1];
        });
      } else {
        text = text.split("=");
        data[text[0]] = text[1];
      }
      return data;
    } else {
      return {};
    }
  }
export default {
    getDate,
    parseQueryString
  };


// WEBPACK FOOTER //
// ./src/assets/js/utils.js